import { render, staticRenderFns } from "./SectionIntro.vue?vue&type=template&id=316cb2b9&"
import script from "./SectionIntro.vue?vue&type=script&lang=js&"
export * from "./SectionIntro.vue?vue&type=script&lang=js&"
import style0 from "./SectionIntro.vue?vue&type=style&index=0&id=316cb2b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports